import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../shared/Icon';
import { MOCK_WORKOUTS, MOCK_LOGS } from '../../utils/mockData';
import './BottomNav.css';

const NAV_ITEMS = [
  { id: 'menu',      iconName: 'menu',     label: 'Menu',      to: null },
  { id: 'clipboard', iconName: 'workouts', label: 'Workouts',  to: '/app/workouts' },
  { id: 'home',      iconName: 'home',     label: 'Home',      to: '/app/dashboard' },
  { id: 'calendar',  iconName: 'schedule', label: 'Schedule',  to: '/app/schedule' },
  { id: 'feed',      iconName: 'feed',     label: 'Feed',      to: '/app/feed' },
];

export default function BottomNav({ onMenuOpen }) {
  const hasPendingToday = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);
    const todayWorkouts = MOCK_WORKOUTS.filter((w) => w.scheduledDate === today);
    if (!todayWorkouts.length) return false;
    const completedIds = new Set(MOCK_LOGS.filter((l) => l.completed).map((l) => l.workoutId));
    return todayWorkouts.some((w) => !completedIds.has(w.id));
  }, []);
  return (
    <nav className="bottom-nav" aria-label="App navigation">
      {NAV_ITEMS.map(({ id, iconName, label, to }) => {
        if (!to) {
          return (
            <button
              key={id}
              className="bottom-nav__item bottom-nav__item--btn"
              onClick={onMenuOpen}
              aria-label={label}
              type="button"
            >
              <span className="bottom-nav__icon"><Icon name={iconName} size={20} /></span>
              <span className="bottom-nav__label">{label}</span>
            </button>
          );
        }

        return (
          <NavLink
            key={id}
            to={to}
            className={({ isActive }) =>
              `bottom-nav__item ${isActive ? 'bottom-nav__item--active' : ''}`
            }
            aria-label={label}
          >
            <span className={`bottom-nav__icon${id === 'clipboard' && hasPendingToday ? ' bottom-nav__icon--pending' : ''}`}>
              <Icon name={iconName} size={20} />
            </span>
            <span className="bottom-nav__label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
